import { faqList } from "src/data/pricingPersonalData";
import FooterPersonalPrice from "./footer/footercomponent";
import { Accordion } from "../general/accordion";
import Link from "next/link";

const FooterPricing = () => {
  return (
    <>
      <FooterPersonalPrice />
      <p className="w-[80%] text-center font-bold text-3xl lg:w-full lg:text-6xl">
        Frequently asked questions
      </p>
      <div className="mb-10 flex w-full flex-col items-center justify-center">
        {faqList.map((item, index) => (
          <Accordion
            key={index}
            className="@container mt-5 w-3/4"
            contentClassName=""
            trigger={
              <div className="flex h-16 w-full items-center justify-start rounded-lg">
                <span className="flex w-10/12 items-center justify-start text-xl">
                  {item.title}
                </span>
              </div>
            }
          >
            {item.url
              ? [
                  <div className="mt-2 mb-2" key={index}>
                    <Link
                      href={item.url}
                      style={{
                        color: "#DEDEDE",
                      }}
                      target="_blank"
                      className="w-8/12 text-lg"
                    >
                      {item.description}
                    </Link>
                  </div>,
                ]
              : [
                  <div key={index} className="mt-2 mb-2 w-10/12">
                    <span className="w-10/12 text-lg">{item.description}</span>
                  </div>,
                ]}
          </Accordion>
        ))}
      </div>
    </>
  );
};

export default FooterPricing;
